import React, { useEffect, useState } from 'react';
import { Dialog } from '@headlessui/react';
import { LuShieldOff } from 'react-icons/lu';
import SafetyDialog, { DialogIcon, Spinner, btnSecondary, btnBrand } from './SafetyDialog';
import { safetyApi, apiError } from './safetyApi';

// Desbloquear (DELETE /api/v1/user/block/{id}). No es destructivo: color de marca.
export default function UnblockUserModal({ open, user, onClose, afterLeave, onUnblocked }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { if (open) setError(''); }, [open]);

  const name = user?.nickname || user?.name;

  const unblock = async () => {
    setBusy(true);
    setError('');
    try {
      await safetyApi.unblock(user.id);
      onUnblocked?.(user);
      onClose();
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <SafetyDialog open={open} onClose={onClose} busy={busy} afterLeave={afterLeave}>
      <DialogIcon icon={LuShieldOff} tone="brand" />
      <Dialog.Title className="mt-3 text-lg font-semibold">Desbloquear usuario</Dialog.Title>
      <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
        {name || 'Este usuario'} podrá volver a escribirte y ver tu perfil.
      </p>
      {error && <p className="mt-3 text-sm text-red-500"><b>No se pudo desbloquear.</b> {error}</p>}
      <div className="mt-5 flex gap-2">
        <button onClick={onClose} disabled={busy} className={btnSecondary}>Cancelar</button>
        <button onClick={unblock} disabled={busy} className={btnBrand}>
          {busy && <Spinner />} Desbloquear
        </button>
      </div>
    </SafetyDialog>
  );
}
